"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticDot = void 0;
const staticDot = 'hsl(204, 100%, 65%)';
exports.staticDot = staticDot;
